import axios from "axios";
import { QuebicSpaceMemberUpdate } from "../../types/space";
import { Controller } from "./controller";

export class Member extends Controller {
	protected get base(): string {
		return `${super.base}/space`;
	}

	/**
	 * Kicks or (removes) a member from the given space.
	 * @param space_id 
	 * @param user_id 
	 */
	public async kick(space_id: string, user_id: string) {
		await this.fetch(axios.delete(`${this.base}/${space_id}/members/${user_id}`, this.configAuth));
	}

	/**
	 * Updates one or more attributes of a member of the given space.
	 *
	 * @param {string} space_id
	 * @param {string} user_id
	 * @param {QuebicSpaceMemberUpdate} updates
	 * @memberof Member
	 */
	public async update(space_id: string, user_id: string, updates: QuebicSpaceMemberUpdate) {
		await this.fetch(axios.patch(`${this.base}/${space_id}/members/${user_id}`, updates, this.configAuth));
	}
}